import { useHistory } from "react-router";
import { useFlowPath } from "../../hooks/use-flow-path";
import { routes } from "../config/routes";

export const useRoutes = () => {
  const history = useHistory();
  const flowPath = useFlowPath();

  const goToRoute = (route: string) => () => {
    history.push(flowPath(route));
  };

  return {
    goToValidateUser: goToRoute(routes.validateUser.raw()),
    goToPickVoucher: goToRoute(routes.pickVoucher.raw()),
    goToCodeValidation: goToRoute(routes.codeValidation.raw()),
    goToCheckout: goToRoute(routes.checkout.raw()),
    goToThankYou: goToRoute(routes.thankYou.raw()),
    goToPickUpsell: goToRoute(routes.pickUpsell.raw()),
    goToTermsAgreement: goToRoute(routes.termsAgreement.raw()),
  };
};
